<template>
  <div>
    <div class="card">
      <div class="row row-bordered no-gutters ui-bordered">
        <v-product
          v-for="(product, index) in products"
          :id="`product-${index}`"
          :key="product.id"
          :product="product"
          :is-buyable="product.price <= user.coin_account.rate"
          :show-buy-button="user.isAuthenticated"
          :index="index"
          @product-selected="openProductModal"
        />
      </div>
    </div>

    <v-product-order-modal
      v-if="productSelected"
      :product="productSelected"
      @hide-modal="productSelected = null"
    />
  </div>
</template>

<script>
import api from '@/common/api';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import Product from '@/common/components/coins/Product.vue';
import ProductOrderModal from '@/common/components/coins/ProductOrderModal.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductList',
  components: {
    'v-product': Product,
    'v-product-order-modal': ProductOrderModal,
  },
  data() {
    return {
      products: null,
      productSelected: null,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async getProducts() {
      const response = await api.get('public/products');
      this.products = response.data;
    },
    openProductModal(product) {
      this.productSelected = product;
    },
  },
  created() {
    this.getProducts();
    setBreadcrumbs('productList');
  },
};
</script>
